import { render, staticRenderFns } from "./QuoteFreightsEstimatesFormDialog.vue?vue&type=template&id=dc8b9530&"
import script from "./QuoteFreightsEstimatesFormDialog.vue?vue&type=script&lang=ts&"
export * from "./QuoteFreightsEstimatesFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports